export default "__VITE_ASSET__XGcgQ2mQOkKDcm8NfeR2fw__"